function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m7.25 20h-.25v-11.5c0-1.465-1.266-2.639-2.761-2.487-1.301.133-2.239 1.327-2.239 2.635v11.352h-.25c-.965 0-1.75.785-1.75 1.75v.5c0 .965.785 1.75 1.75 1.75h5.5c.965 0 1.75-.785 1.75-1.75v-.5c0-.965-.785-1.75-1.75-1.75z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m17.702 9-4 6h3.096l4-6z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m11.952 9-4 6h3.346l4-6z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m23.062 9.209-3.86 5.791h3.048c.965 0 1.75-.785 1.75-1.75v-2.5c0-.67-.383-1.247-.938-1.541z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m9.548 9h-3.548v5.323z"
});

function Svg312(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "inherit",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg312);
export default __webpack_public_path__ + "static/media/3_12.84e1ca17.svg";
export { ForwardRef as ReactComponent };